import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/minimize.tsx
var Minimize = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M14 4.00003V9.00003C14 9.55232 14.4477 10 15 10H20M10 20V15C10 14.4477 9.55228 14 9 14H4M15 9.00003L20.25 3.75003M9 15L3.75 20.25",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.7803 3.21967C21.0732 3.51256 21.0732 3.98744 20.7803 4.28033L15.8107 9.25H20C20.4142 9.25 20.75 9.58579 20.75 10C20.75 10.4142 20.4142 10.75 20 10.75H15C14.0335 10.75 13.25 9.9665 13.25 9V4C13.25 3.58579 13.5858 3.25 14 3.25C14.4142 3.25 14.75 3.58579 14.75 4V8.18934L19.7197 3.21967C20.0126 2.92678 20.4874 2.92678 20.7803 3.21967ZM3.25 14C3.25 13.5858 3.58579 13.25 4 13.25H9C9.9665 13.25 10.75 14.0335 10.75 15V20C10.75 20.4142 10.4142 20.75 10 20.75C9.58579 20.75 9.25 20.4142 9.25 20V15.8107L4.28033 20.7803C3.98744 21.0732 3.51256 21.0732 3.21967 20.7803C2.92678 20.4874 2.92678 20.0126 3.21967 19.7197L8.18934 14.75H4C3.58579 14.75 3.25 14.4142 3.25 14Z",
		fill: "currentColor"
	})
});
//#endregion
export { Minimize };
